import { Injectable } from '@angular/core';
import { AbstractGraphqlRequest, GraphqlRequestType } from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class SolutionExistsRequestQuery extends AbstractGraphqlRequest<boolean> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query solutionExists($payload: SolutionRequestPayloadInput!) {
        solutionExists(payload: $payload)
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    if (typeof data.solutionExists === 'boolean') {
      return data.solutionExists;
    }

    return false;
  }
}
